import "./DashboardPage.css";
import FoveaAILogo from "../../assets/images/foveaai_logo_dark_text.svg";

import React from "react";
import JobDetailForm from "../../components/JobDetailForm/JobDetailForm";
import JobTable from "../../components/JobTable/JobTable";
import { Modal, Container, Button } from "react-bootstrap";

function DashboardPage() {
    const [showEditModal, setShowEditModal] = React.useState(false);

    const handleEditModalClose = () => {
        setShowEditModal(false);
    };

    return (
        <Container>
            <Modal
                show={showEditModal}
                onHide={() => setShowEditModal(false)}
                size="lg"
                aria-labelledby="contained-model-title-vcenter"
                centered
                dialogClassName="job-detail-form-modal-custom"
            >
                <Modal.Body className="job-detail-form-modal-body-custom">
                    <JobDetailForm
                        jobId={null}
                        closeModal={handleEditModalClose}
                    />
                </Modal.Body>
            </Modal>

            <div className="dashboard-info-container">
                <img
                    className="dashboard-info-logo"
                    src={FoveaAILogo}
                    alt="FoveaAI Logo"
                />
                {/* <div className="dashboard-tagline">
                    Identify top candidates in minutes.
                </div> */}
            </div>
            <div className="dashboard-container">
                <div className="dashboard-heading-container">
                    <div className="common-page-heading">
                        <h1>Open Jobs</h1>
                    </div>
                    <Button
                        variant="success"
                        className="common-buttons-container"
                        onClick={() => setShowEditModal(true)}
                    >
                        Add Job
                    </Button>
                </div>
                <JobTable />
            </div>
        </Container>
    );
}

export default DashboardPage;
